import { daysBetween } from "@/logic/getStayLength"
import ParticipantInsurance from "./Insurance/ParticipantInsurance"
import AccomodationService from "./Service/AccomodationService"
import ParticipantService from "./Service/ParticipantService"

export interface IPrestation {
    getIdFull(): string
    getIdShort(): string
    getQuantity(): number | undefined
    setQuantity(quantity: number): void
    getStartDate(): string | undefined
    setStartDate(startDate: string): void
    getEndDate(): string | undefined
    setEndDate(endDate: string): void
    getDuration(): number
}

class Prestation implements IPrestation {
    protected id: string
    protected quantity?: number
    protected startDate?: string
    protected endDate?: string


    constructor(
        id: string,
        quantity?: number,
        startDate?: string,
        endDate?: string,
    ) {
        this.id = id
        this.quantity = quantity
        this.startDate = startDate
        this.endDate = endDate
    }


    public getIdFull(): string {
        return this.id
    }
    public getIdShort(): string {
        const split = this.id.split("_")
        const id = split[split.length - 1]
        return id
    }

    public getQuantity(): number | undefined {
        return this.quantity
    }
    public setQuantity(quantity: number): void {
        this.quantity = quantity
    }
    public getStartDate(): string | undefined {
        return this.startDate
    }
    public setStartDate(startDate: string): void {
        this.startDate = startDate
    }
    public getEndDate(): string | undefined {
        return this.endDate
    }
    public setEndDate(endDate: string): void {
        this.endDate = endDate
    }
    public getDuration(): number {
        if (!this.startDate || !this.endDate) return NaN 
        return daysBetween(this.startDate, this.endDate)
    }


}

export default Prestation